import React from 'react';
import PropTypes from 'prop-types';

import Table from '../Table';
import { AllSizeGuideTables } from './Data';

/**
 * Tables for Size Guide
 */
const SizeGuideTable = ({
  businessLine,
  sizeSchema,
  tableName,
}: {
  businessLine: string;
  sizeSchema: string;
  tableName: string;
}) => {
  const tableData = // @ts-ignore-next-line
    AllSizeGuideTables[businessLine.toLowerCase()][sizeSchema][tableName];

  const cellWidth = () => {
    if (sizeSchema === 'sizeComparison') {
      return 'small';
    }

    if (businessLine === 'WOMENS') {
      return 'medium';
    }

    if (businessLine === 'MENS') {
      return 'large';
    }

    return 'small';
  };

  return (
    <Table
      hasDarkenedFirstColumn={sizeSchema === 'sizeComparison'}
      headerRowGroups={tableData.header}
      tableBodyRowGroups={tableData.body}
      computeTableBodyRowStyle={index => {
        return index % 2 === 0 ? 'trDefault' : 'trShade';
      }}
      cellWidth={cellWidth()}
    />
  );
};

SizeGuideTable.propTypes = {
  businessLine: PropTypes.string.isRequired,
  sizeSchema: PropTypes.string.isRequired,
  tableName: PropTypes.string.isRequired,
};

export default SizeGuideTable;
